import React, { useState, useEffect } from 'react';
import { Form, FormGroup, FormText, Button } from 'reactstrap';
import CKEditor from '@ckeditor/ckeditor5-react';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import Axios from 'axios';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

import TextFieldGroup from '../../Common/TextFieldGroup';
import DateTimePickerFieldGroup from '../../Common/DateTimePickerFieldGroup';
import SelectFieldGroup from '../../Common/SelectFieldGroup';
import ProgressIndicator from '../../Common/ProgressIndicator';
import { Task } from '../../../Data/Classes';
import { taskStateToString } from '../../../Utils/Converters';

function TaskEditForm(props) {
    const [isProgress, setIsProgress] = useState(false);
    const [error, setError] = useState({});
    const [task, setTask] = useState(null);

    useEffect(() => {
        setTask({
            ...props.task,
            deadline: moment(new Date(props.task.deadline))
        });
    }, []);

    function onChange(e) {
        setTask({ ...task, [e.target.name]: e.target.value });
    }

    function onDelete(e) {
        if (window.confirm("Biztos, hogy törlöd a feladatot?\nA művelet nem visszavonható.")) {
            setIsProgress(true);
            Axios.delete(`/admin/events/${task.eventId}/tasks/${task.id}`)
                .then(res => {
                    setIsProgress(false);
                    toast.success(`${task.name} törölve.`);
                    window.history.back();
                }, err => {
                    setIsProgress(false);
                    toast.error("A feladat törlése sikertelen volt.");
                });
        }
    }

    function onSubmit(e) {
        e.preventDefault();
        setIsProgress(true);
        Axios.post(`/admin/events/${task.eventId}/tasks/${task.id}`,
            new Task(task.id,
                task.name,
                task.description,
                task.remark,
                task.pointValue,
                task.neededPeople,
                new Date(task.deadline.toDate().setSeconds(0)),
                task.deleted,
                task.state,
                task.eventId))
            .then(res => {
                setIsProgress(false);
                toast.success(`${task.name} elmentve.`);
                window.history.back();
            }, err => {
                setIsProgress(false);
                setError(err.errors);
                toast.error("A feladat mentése sikertelen volt.");
            });
    }

    if (isProgress)
        return <ProgressIndicator />;

    if (task) {
    return (
        <Form onSubmit={onSubmit} id="taskEditForm">
            <FormGroup>
                <FormGroup row>
                    <TextFieldGroup className="col-lg-12"
                        field="name"
                        onChange={onChange}
                        label="Név"
                        error={error.Name}
                        value={task.name} />
                </FormGroup>
                <FormGroup row>
                    <TextFieldGroup className="col-lg-4"
                        field="pointValue"
                        onChange={onChange}
                        type="number"
                        label="Max. pontérték"
                        error={error.PointValue}
                        value={task.pointValue} />
                    <TextFieldGroup className="col-lg-4"
                        field="neededPeople"
                        onChange={onChange}
                        type="number"
                        label="Szükséges emberszám"
                        error={error.NeededPeople}
                        value={task.neededPeople} />
                    <DateTimePickerFieldGroup className="col-lg-4"
                        field="deadline"
                        onChange={onChange}
                        type="datetime-local"
                        label="Dátum"
                        error={error.Deadline}
                        value={task.deadline} />
                </FormGroup>
                <FormGroup row>
                    <SelectFieldGroup className="col-lg-4"
                        field="state"
                        onChange={onChange}
                        label="Állapot"
                        error={error.State}
                        value={task.state}>
                        {new Array(3).fill(0).map((value, index) => {
                            return <option value={index} key={index}>{taskStateToString(index)}</option>
                        })}
                    </SelectFieldGroup>
                    <TextFieldGroup className="col-lg-8"
                        field="remark"
                        onChange={onChange}
                        label="Megjegyzés (adminoknak)"
                        error={error.Remark}
                        value={task.remark} />
                </FormGroup>
                <FormGroup>
                    <label>Leírás</label>
                    <CKEditor
                        editor={DecoupledEditor}
                        data={task.description}
                        onInit={editor => {
                            editor.ui.view.editable.element.parentElement.insertBefore(
                                editor.ui.view.toolbar.element,
                                editor.ui.view.editable.element);
                        }}
                        onChange={(ev, editor) => {
                            setTask({ ...task, description: editor.getData() });
                        }}
                    />
                    {error.Description && <FormText>{error.Description}</FormText>}
                </FormGroup>
            </FormGroup>

            {error[""]}
            <Button color="primary" type="submit"><FontAwesomeIcon icon={faCheck} /> Mentés</Button>
            <Button color="primary" type="button" onClick={(e) => window.history.back()}><FontAwesomeIcon icon={faArrowLeft} /> Mégsem</Button>
            <Button color="warning" type="button" onClick={onDelete} className="float-right"><FontAwesomeIcon icon={faTrash} /> Törlés</Button>
        </Form >
        );
    }
    return null;
}

export default TaskEditForm;
